import React from 'react';

import { useApp } from '../../store/AppContext';
import PasswordForm from '../PasswordForm';

export default function PasswordRecoveryCard({ invite }) {
  const { profile } = useApp();
  return (
    <div className="bg-white p-[32px] w-[420px] shadow-[0_4px_24px_rgba(0,0,0,.06)] rounded-[16px] [border:0.5px_solid_#e5e3de]">
      <img src="/uptime-logo-color.svg" alt="Uptime" className="h-[34px] mb-[20px] w-[auto]" />
      <div className="font-bold text-[20px] text-navy mb-[4px]">
        {invite
          ? `Bienvenue${profile?.nom ? ' ' + profile.nom : ''} !`
          : 'Définir un nouveau mot de passe'}
      </div>
      <div className="text-[13px] text-slate mb-[24px]">
        {invite
          ? "Créez votre mot de passe pour accéder à l'ERP d'Uptime."
          : 'Choisissez un mot de passe sécurisé pour votre compte.'}
      </div>
      <PasswordForm invite={invite} />
    </div>
  );
}
